import { Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import styled from 'styled-components'
import { light } from '~/constants/theme'
import DynamicTranscriptText from '~/pages/CallAnalytics/Transcription/DynamicTranscriptText'
import TranscriptEntryHeader from '~/pages/CallAnalytics/Transcription/TranscriptEntryHeader'
import { colorPalette } from '~/themes/colors/colorPalette'
import { textStyleKeys } from '~/themes/textStyles'
import { TranscriptEntry } from '~/types/CallTranscript'

const TranscriptionEntryWrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-wrap: break-word;
  padding: 12px;
  background-color: ${(props) =>
    props.isActive ? colorPalette.gray[300] : colorPalette.gray[100]};
  border-radius: 4px;
  &:hover {
    background-color: ${light.gray300};
  }
  margin-bottom: 2px;
`

const StaticTranscriptText = styled.span`
  color: ${light.dark900};
`

interface TranscriptionEntryProps {
  index: number
  transcriptEntry: TranscriptEntry
  transcriptName: string
  childRefFunc?: (ref: HTMLDivElement | null) => void
  isActive?: boolean
  isWaiting?: boolean
  isPlaying: boolean
}

const TranscriptionEntry = ({
  index,
  transcriptEntry,
  transcriptName,
  childRefFunc,
  isActive = true,
  isPlaying,
}: TranscriptionEntryProps) => {
  const [hovered, setHovered] = useState(false)

  const getPersonId = (agentName) => {
    switch (agentName) {
      case 'AGENT':
        return 0
      case 'CUSTOMER':
        return 1
      default:
        return 2
    }
  }

  const personId = getPersonId(transcriptEntry.ParticipantRole)
  return (
    <TranscriptionEntryWrapper
      ref={(r) => childRefFunc?.(r)}
      isActive={isActive}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <TranscriptEntryHeader
        transcriptId={transcriptName}
        personId={personId}
        personName={
          transcriptEntry.ParticipantRole === 'AGENT' ? 'Office' : 'Patient'
        }
        beginOffsetMillis={transcriptEntry.BeginOffsetMillis}
        isActive={isActive}
        isHovered={hovered}
        isPlaying={isPlaying}
      />
      <Text
        textStyle={textStyleKeys.Body2}
        paddingLeft="64px"
        textAlign="justify"
      >
        {isActive ? (
          <DynamicTranscriptText
            index={index}
            transcriptEntry={transcriptEntry}
          />
        ) : (
          <StaticTranscriptText>{transcriptEntry.Content}</StaticTranscriptText>
        )}
      </Text>
    </TranscriptionEntryWrapper>
  )
}

export default TranscriptionEntry
